__turbopack_context__.v({
  "root": "FallbackImage-module-scss-module__1RbUKG__root",
  "svg": "FallbackImage-module-scss-module__1RbUKG__svg",
});
